import Vuex from 'vuex'
import Vue from 'vue'
import Auth from "./modules/auth"
import ViewController from "./modules/viewController"
import errors from "./modules/errors"
import imageController from "./modules/imageController"
import settings from "./modules/settings"
import notification from "./modules/notification"
import Pom from "./modules/Pom"
import spotify from "./modules/spotify"
import cometChatUsers from "./modules/cometChatUsers"

// Load Vuex
Vue.use(Vuex)

// Create store
export default new Vuex.Store({
    modules: {
        Auth,
        ViewController,
        errors,
        imageController,
        settings,
        notification,
        Pom,
        spotify,
        cometChatUsers
    },
})